/* tslint:disable */
/* eslint-disable */
export enum WorkChatTypeEnum {
  Project = 'project',
  Direct = 'direct',
  Group = 'group'
}
